import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, MobTxtExpanderDirective, SwiperDirective } from '@pro-connect/shared';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-pillar-tiles',
  templateUrl: './pillar-tiles.component.html',
  styleUrls: ['./pillar-tiles.component.scss'],
  imports: [CommonModule, RouterModule, AnimateModule, SwiperDirective, MobTxtExpanderDirective],
})
export class PillarTilesComponent {
  public tiles = input.required<{ img: string; title: string; desc: string }[]>();
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public readonly swiperConfig: SwiperOptions = {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    // effect: 'coverflow',
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 3,
        initialSlide: 1,
        watchOverflow: true,
      },
    },
    watchOverflow: true,
    pagination: {
      el: '.app-pil-til__cont__swi__nav--pag',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.app-pil-til__cont__swi__nav--next',
      prevEl: '.app-pil-til__cont__swi__nav--prev',
    },
    on: {
      slideChange: (_) => {
        this.onSLideChangePushLayer(_);
      },
    },
  };

  public slieChangeLayer(pageCategory: string, slideTitle: string, destinationUrl: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: pageCategory,
      eventAction: `select::slider navigation`,
      eventLabel: `${slideTitle}::${destinationUrl}`,
      event_name: 'slider_button_click',
      cta_name: slideTitle,
      link_url: destinationUrl,
    });
  }

  public onSLideChangePushLayer($event: any): void {
    this.slieChangeLayer('range page', this.tiles()[$event.activeIndex].title, '');
  }
}
